import { render } from "./FileViewComponent.vue?vue&type=template&id=0b106b90&ts=true"
import script from "./FileViewComponent.vue?vue&type=script&lang=ts"
export * from "./FileViewComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__